import React from 'react';
import { useParams } from 'react-router-dom';
import RequestsExplorer from '../components/Requests/RequestsExplorer';
import { resolveRequestPreset } from '../config/requestPresets';

const PresetRequestsPage = ({ forcedPresetKey = null }) => {
  const { presetKey: routePresetKey } = useParams();
  const preset = resolveRequestPreset(forcedPresetKey || routePresetKey);

  return <RequestsExplorer preset={preset} />;
};

export default PresetRequestsPage;
